<template>
  <b-card no-body>
    <b-card-body>
      <b-card bg-variant="light">
        <b-form-row @keyup.enter="load" class="align-items-center">
          <b-col lg="6" sm="12" class="text-left">
            <lg-form-input v-model="form.descricao" label="Descrição:" description=" " />
          </b-col>

          <b-col lg="2" sm="12" class="text-left">
            <lg-form-const-select label="Situação:" @change="load()" v-model="form.situacao"
              :options="form.optionsFilterSituacao" />
          </b-col>

          <b-col lg="1" sm="1" class="ml-4 d-flex justify-content-end align-items-center">
            <b-button id="limpar" class="my-2" size="sm" style="height: 20px" pill variant="primary" @click="limpar">
              <div class="btn-size-alinhamento">
                <b-icon icon="eraser" />
              </div>
              <b-tooltip target="limpar" title="Limpar"></b-tooltip>
            </b-button>

            <b-button id="localizar" class="ml-3 mr-2 my-2" size="sm" style="height: 20px" pill variant="primary"
              @click="load">
              <div class="btn-size-alinhamento">
                <b-icon icon="search" />
              </div>
              <b-tooltip target="localizar" title="Localizar"></b-tooltip>
            </b-button>
          </b-col>

          <b-col lg="2" sm="12" class="text-right d-flex justify-content-end align-items-center">
            <b-button v-if="temPrivilegioCadastro()" id="novo" class="ml-3 mr-2 my-2" style="height: 20px"
              @click="mostrarModalForm(null)" size="sm" pill variant="secondary">
              <div class="btn-size-alinhamento">
                <b-icon scale="1" icon="plus" />
              </div>
              <b-tooltip target="novo" title="Adicionar novo..."></b-tooltip>
            </b-button>
          </b-col>
        </b-form-row>

        <b-table responsive class="mt-2" small :busy="this.busy" :items="this.records" :fields="this.tableFields"
          :hover="true" @row-dblclicked="especificacaoSelect" show-empty>
          <template #table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </template>
          <template #empty>
            <p>Nenhum registro encontrado</p>
          </template>

          <template v-slot:cell(situacao)="row">
            <div :id="row.index + 'switchGrupo'">
              <b-form-checkbox v-model="row.item.situacao" @change="ativaInativa(row.item)" name="check-button" switch
                size="lg" :value="1" :unchecked-value="0" />
              <b-tooltip :target="row.index + 'switchGrupo'" title="Ativar/Desativar..."></b-tooltip>
            </div>
          </template>
          <template v-slot:cell(editar)="{ item }">
            <b-button v-if="temPrivilegioEdicao()" :id="'editar-' + item.id" class="my-2" size="sm" pill
              variant="primary" @click="mostrarModalForm(item)">
              <b-icon icon="pencil-square" />
              <b-tooltip :target="'editar-' + item.id" title="Editar..." triggers="hover"></b-tooltip>
            </b-button>
          </template>
        </b-table>
        <b-row style="margin-top: 12px" v-if="records && records.length > 0">
          <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
            Página {{ page }} de {{ totalPage }} - {{ total }} registros
          </b-col>
          <b-col cols="6">
            <div class="d-flex justify-content-end align-items-end">
              <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page" :per-page="perPage"
                :total-rows="total"></b-pagination>
            </div>
          </b-col>
        </b-row>
      </b-card>
    </b-card-body>
    <EspecificacaoProdutoForm :produto="produto" :prefix="prefix + title + ' > '" v-if="mostrarForm" :id="id" :almoxarifado="almoxarifado"
      @close="cancelar">
    </EspecificacaoProdutoForm>
  </b-card>
</template>

<script>
import ResourceService from "@/core/api/ResourceService"
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import { ListResourceMixin } from "@/core/mixins/resource"
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"
import EspecificacaoProdutoForm from "./EspecificacaoProdutoForm.vue"
import ConfirmMixin from "@/core/mixins/confirm";



export default {
  components: {
    LgFormInput,
    LgFormConstSelect,
    EspecificacaoProdutoForm,

  },
  props: {
    produto: Object,
    prefix: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "Especificação do Produto",
    },

    almoxarifado: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mostrarForm: false,
      id: null,
      form: {
        descricao: "",
        produto: { descricao: "" },
        situacao: 1,
        optionsFilterSituacao: [
          { key: "filterSituacao", text: "Todos", value: undefined },
          { key: "filterSituacao", text: "Ativo", value: 1 },
          { key: "filterSituacao", text: "Inativo", value: 0 },
        ],
      },
    }
  },
  mixins: [ListResourceMixin, ConfirmMixin],
  beforeMount() {
    if (this.almoxarifado) {
      this.$service = new ResourceService(`/api/especificacao-produto-almoxarifado`)
    } else {
      this.$service = new ResourceService(`/api/especificacao-produto`)
    }
  },
  mounted() {
    this.load()
  },
  watch: {
    page() {
      this.load()
    },
  },
  computed: {
    tableFields() {
      return [
        { key: "produto.numero", label: "Número", tdClass: "w-20" },

        { key: "descricao", label: "Descrição", tdClass: "w-20" },
        { key: "produto.descricaoResumida", label: "Produto", tdClass: "w-20" },
        { key: "situacao", label: " ", tdClass: "w-1" },
        { key: "editar", label: " ", tdClass: "w-1" },

      ]
    },
  },
  methods: {
    mostrarModalForm(item) {
      if (item)
        this.id = item.id;
      this.mostrarForm = true;
    },
    cancelar() {
      this.id = null;
      this.mostrarForm = false;
      this.load();
    },
    temPrivilegioCadastro() {
      return verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_ALMOXARIFADO_INCLUIR);

    },
    temPrivilegioEdicao() {
      return verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_ALMOXARIFADO_EDITAR);

    },
    limpar() {
      this.form.situacao = 1;
      this.form.descricao = "";
      this.load();
    },
    async load() {
      this.filtro = {}
      if (this.produto && this.produto.id)
        this.filtro.produto = this.produto.id;

      if (this.form.descricao) {
        this.filtro.descricao = this.form.descricao
      }
      if (this.form.situacao != null) {
        this.filtro.situacao = this.form.situacao
      }

      this.busy = true
      await this.$loadResource({
        size: this.perPage,
        page: this.page,
        params: this.filtro,
      })
    },

    async ativaInativa(item) {


      let response = await this.$confirm(
        "Deseja " + (item.situacao === 1 ? "ativar" : "inativar") + " a Especificação do Produto?",
        item.descricao.toUpperCase()
      );

      if (response == true) {
        this.confirmarAtivaInativa(item)
      }
      else
        item.situacao = item.situacao === 1 ? 0 : 1
    },

    async confirmarAtivaInativa(item) {
      this.busy = true;
      const { status } = await this.$service.alteraSituacao(item)
      this.busy = false;

      if (status === 200) {
        this.$notify({
          type: "success",
          message: "Registro atualizado com sucesso.",
        })
      } else {
        this.$notify({
          type: "danger",
          message: "Erro ao atualizar o registro.",
        })
      }
    },

    especificacaoSelect(item) {
      this.$emit("onDblClickItem", item)
    },
  },
}
</script>
